module.exports = __webpack_public_path__ + "static/media/roborregos_wharehouse.97aeadd8.jpg";